// src/components/ExportPDF.jsx
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import React from "react";
import {Download} from "lucide-react";

export default function ExportPDF({bookings, title = "Бронирования"}) {
    const exportToPDF = async () => {
        try {
            const element = document.getElementById('pdf-content');

            if (!element) {
                alert('Элемент pdf-content не найден на странице');
                return;
            }

            // Показываем индикатор загрузки
            const button = document.querySelector('[title="Экспорт в PDF"]');
            if (button) button.disabled = true;

            console.log('Начало создания canvas...');

            const canvas = await html2canvas(element, {
                scale: 1.5,
                useCORS: true,
                logging: true,
                backgroundColor: '#ffffff'
            });

            console.log('element : ', element);
            console.log('Canvas создан:', canvas.width, 'x', canvas.height);

            if (!canvas || canvas.width === 0 || canvas.height === 0) {
                throw new Error('Canvas пустой или не создан');
            }

            const imgData = canvas.toDataURL('image/jpeg', 0.95);

            console.log('Image data создан, длина:', imgData.length);

            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;

            const ratio = Math.min(
                (pdfWidth - 20) / canvasWidth,
                (pdfHeight - 20) / canvasHeight
            );

            const imgWidth = canvasWidth * ratio;
            const imgHeight = canvasHeight * ratio;

            const x = (pdfWidth - imgWidth) / 2;
            const y = 10;

            console.log('Добавление изображения в PDF...');
            console.log('Размеры:', imgWidth, 'x', imgHeight, 'позиция:', x, y);

            pdf.addImage(imgData, 'JPEG', x, y, imgWidth, imgHeight);

            const fileName = `hotel-bookings-${Date.now()}.pdf`;
            pdf.save(fileName);

            console.log('PDF успешно сохранён:', fileName);

            if (button) button.disabled = false;

        } catch (error) {
            console.error('Ошибка при создании PDF:', error);
            alert(`Ошибка: ${error.message}`);

            const button = document.querySelector('[title="Экспорт в PDF"]');
            if (button) button.disabled = false;
        }
    };

    return (
        <>
            {/*<button*/}
            {/*    onClick={exportToPDF}*/}
            {/*    className="fixed bottom-28 left-6 z-40 w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-600 text-white rounded-full shadow-2xl hover:scale-110 transition-all flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"*/}
            {/*    title="Экспорт в PDF"*/}
            {/*>*/}
            {/*    <Download size={28}/>*/}
            {/*</button>*/}
            <button
                onClick={exportToPDF}
                className="flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition bg-green-600 border border-gray-300 text-white hover:bg-gray-50"
                title="Экспорт в PDF"
            >
                <Download size={16}/> Отчёт
            </button>
        </>
    );
}
